<template>
  <div class="company">
    <el-form :model="form" ref="myForm" :rules="rules" hide-required-asterisk>
      <!-- sp編號 -->
      <el-form-item
        v-if="viewType == 'search'"
        :label="$t('message.spNo')"
        prop="spNo"
      >
        <el-input
          v-model="form.spNo"
          :placeholder="$t('message.spNo_placeholder')"
          :disabled="viewType == 'search'"
        ></el-input>
      </el-form-item>
      <!-- 澳門駕駛執照編號 -->
      <el-form-item :label="$t('message.macau_driver_no')" prop="licenseNo">
        <el-input
          v-model="form.licenseNo"
          :placeholder="$t('message.macau_driver_no_plh')"
        ></el-input>
      </el-form-item>
      <!-- 身份證明文件類別 -->
      <el-form-item :label="$t('message.idType')" prop="identType">
        <el-select
          v-model="form.identType"
          value-key="code"
          filterable
          @change="identTypeChange"
        >
          <el-option
            v-for="item in idType"
            :key="item.code"
            :label="$t(item.label)"
            :value="item.code"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- 身份證明文件編號 -->
      <el-form-item :label="$t('message.idNo')" prop="identNo">
        <el-input
          v-model="form.identNo"
          :placeholder="$t('message.idNo_plh')"
        ></el-input>
      </el-form-item>
      <!-- 澳門流動電話 -->
      <el-form-item :label="$t('message.Verification.mobile')" prop="mobile">
        <el-input
          v-model.number="form.mobile"
          :placeholder="$t('message.Verification.mobile_placeholder')"
          maxlength="8"
        ></el-input>
      </el-form-item>
      <!-- 手機驗證碼 -->
      <el-form-item
        :label="$t('message.Verification.phone_code')"
        prop="captcha"
      >
        <div class="captcha_row" style="width: 100%">
          <el-input
            v-model="form.captcha"
            :placeholder="$t('message.Verification.phone_code_placeholder')"
            @keyup.enter.native="submit"
          ></el-input>
          <el-button
            v-show="show"
            type="primary"
            class="getVerify_btn"
            @click="getCode"
            :disabled="!this.form.mobile"
            :loading="getCodeLoading"
            >{{ $t("message.get_phone_code") }}</el-button
          >
          <el-button
            v-show="!show"
            type="primary"
            class="getVerify_btn"
            disabled
            >{{ count }}{{ $t("message.second") }}</el-button
          >
        </div>
      </el-form-item>
      <el-form-item class="submit_btn">
        <GradientBtn @click="submit" :loading="loading">{{
          $t("message.verify_submit")
        }}</GradientBtn>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import i18n from "../../../../public/lang/index";
import GradientBtn from "../../../components/GradientBtn";
import LoginAPI from "../../../api/LoginAPI";
import DrivIntApplicationAPI from "../../../api/DrivIntApplicationAPI";
export default {
  components: { GradientBtn },
  data() {
    let validcodeMacauMobile = (rule, value, callback) => {
      // 驗證澳門手機
      let reg = /[6]{1}[0-9]{7}/;
      if (value && !reg.test(value)) {
        callback(new Error(i18n.t("message.formRuleMessage.macauMobile")));
      } else {
        callback();
      }
    };
    let identityNoCheck = (rule, value, callback) => {
      // 驗證澳門居民身份證編號
      let reg = /^[0-9]{8}$/;
      if (this.form.identType === "BM" && value && !reg.test(value)) {
        callback(new Error(i18n.t("message.formRuleMessage.identityNo")));
      } else {
        callback();
      }
    };
    return {
      // form: {},
      show: true,
      loading: false,
      getCodeLoading: false,
      timer: null,
      count: "",
      isGetCode: false,
      rules: {
        mobile: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
          },
          { validator: validcodeMacauMobile, trigger: "blur" },
        ],
        captcha: [
          {
            max: 10,
            message: i18n.t("message.formRuleMessage.maxLength10"),
            trigger: "blur",
          },
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
            trigger: "blur",
          },
        ],
        licenseNo: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
            trigger: "blur",
          },
          {
            max: 20,
            message: i18n.t("message.formRuleMessage.maxLength20"),
            trigger: "blur",
          },
        ],
        identType: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
            trigger: "blur",
          },
        ],
        identNo: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
            trigger: "blur",
          },
          {
            max: 20,
            message: i18n.t("message.formRuleMessage.maxLength20"),
            trigger: "blur",
          },
          { validator: identityNoCheck, trigger: "blur" },
        ],
      },
      idType: [
        { code: "BM", label: "message.idType_macau" },
        {
          code: "OTHER",
          label: "message.idType_other",
        },
      ],
    };
  },
  computed: {
    form: {
      get() {
        return this.$store.state.verifyForm;
      },
      set(value) {
        this.$store.commit("changeVerifyForm", value);
      },
    },
    serviceType() {
      return this.$route.params.serviceType;
    },
    viewType() {
      return this.$store.state.viewType;
    },
  },
  methods: {
    getCode() {
      this.rules.captcha.splice(1, 1);
      this.$refs.myForm.validate((valid) => {
        if (valid) {
          const TIME_COUNT = 60;
          if (!this.timer) {
            this.count = TIME_COUNT;
            const mobile = this.form.mobile;
            const serviceType = this.serviceType;
            const spNo = this.form.spNo || null;
            const identNo = this.form.identNo || null;
            if (serviceType == "DRV_LIC_INTER" && mobile) {
              this.getCodeLoading = true;
              LoginAPI.captcha(
                mobile,
                serviceType,
                spNo,
                null,
                null,
                null,
                identNo
              )
                .then(() => {
                  this.getCodeLoading = false;
                  this.show = false;
                  this.isGetCode = true;
                  this.timer = setInterval(() => {
                    if (this.count > 0 && this.count <= TIME_COUNT) {
                      this.count--;
                    } else {
                      this.show = true;
                      clearInterval(this.timer);
                      this.timer = null;
                    }
                  }, 1000);
                })
                .catch((err) => {
                  this.getCodeLoading = false;
                  this.$error(err);
                });
            } else {
              this.$refs.myForm.validateField("taxiCertNo");
            }
          }
          this.rules.captcha.push({
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
            trigger: "blur",
          });
        } else {
          this.rules.captcha.push({
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
            trigger: "blur",
          });
        }
      });
    },

    submit() {
      if (!this.isGetCode) {
        this.$message({
          type: "warning",
          message: this.$t("message.getCode_first"),
        });
        return false;
      }
      this.$refs.myForm.validate((valid) => {
        if (valid) {
          // 國際駕駛執照申請
          if (this.serviceType == "DRV_LIC_INTER") {
            this.internationCheck();
            return false;
          }
        }
      });
    },
    // 驗證國際服務准入條件
    internationCheck() {
      const viewType = this.viewType;
      const serviceType = this.serviceType;
      const mobile = this.form.mobile;
      const captcha = this.form.captcha;
      const identType = this.form.identType;
      const identNo = this.form.identNo;
      const licenseNo = this.form.licenseNo;
      const spNo = this.form.spNo;
      this.loading = true;
      LoginAPI.mobileCheck(serviceType, mobile, captcha)
        .then((res) => {
          localStorage.setItem("authentication", res.authentication);
          DrivIntApplicationAPI.check(
            serviceType,
            identType,
            identNo,
            licenseNo,
            spNo
          )
            .then((res) => {
              this.loading = false;
              const errSpCode = [
                "D01",
                "D02",
                "D11",
                "D21",
                "D23",
                "D41",
                "D99",
                "T01",
                "T06",
              ];
              if (
                res &&
                res.application &&
                errSpCode.includes(res.application.spCode)
              ) {
                this.$message({
                  type: "error",
                  message: res.application.spResultCn,
                });
              } else {
                localStorage.setItem("form", "");
                this.$store.commit("changeDocumentType", []);
                localStorage.setItem("drivApplication", JSON.stringify(res));
                this.$store.commit("changeDrivApplication", res);
                localStorage.setItem("verifyForm", JSON.stringify(this.form));
                this.$router.push(
                  viewType == "search" ? "/search/status" : "/international"
                );
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$error(err);
            });
        })
        .catch((err) => {
          this.loading = false;
          this.$error(err);
        });
    },
    identTypeChange(val) {
      this.$refs.myForm.validate();
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.captcha_row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.getVerify_btn {
  margin-left: 16px;
  min-width: 150px;
}
.submit_btn {
  text-align: center;
  margin: 76px 0;
}
</style>